import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  GET_CUSTOMER_RELEASE_SIGNATURES,
  GET_CUSTOMER_LATEST_RELEASE_SIGNATURE,
  GET_RELEASE_BY_NAME,
  GET_ALL_RELEASES,
  CREATE_RELEASE,
  UPDATE_RELEASE,
} from "../../configs";

export interface CustomerReleaseSignatureResponse {
  id: number;
  customerId: number;
  releaseId: number;
  releaseName: string;
  releaseDescription: string;
  signatureImage: string;
  signedAt: string;
  employeeId: number;
  employeeName: string;
  employeeEmail: string;
  cashierPointId: number | null;
  cashierPointName: string | null;
  storeId: number;
  createdAt: string;
}

export const getCustomerReleaseSignaturesAction = createAsyncThunk(
  "customerReleaseSignature/getAll",
  async (customerId: number, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_CUSTOMER_RELEASE_SIGNATURES(customerId));
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data ?? error.message);
    }
  }
);

export interface ReleaseDto {
  id: number;
  name: string;
  description: string;
  agreementText: string | null;
  active: boolean;
}

export const getReleaseByNameAction = createAsyncThunk(
  "customerReleaseSignature/getReleaseByName",
  async (name: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_RELEASE_BY_NAME(name));
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data ?? error.message);
    }
  }
);

export const getAllReleasesAction = createAsyncThunk(
  "release/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_ALL_RELEASES);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data ?? error.message);
    }
  }
);

export const createReleaseAction = createAsyncThunk(
  "release/create",
  async (dto: Omit<ReleaseDto, "id">, { rejectWithValue }) => {
    try {
      const response = await axios.post(CREATE_RELEASE, dto);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data ?? error.message);
    }
  }
);

export const updateReleaseAction = createAsyncThunk(
  "release/update",
  async (
    { id, dto }: { id: number; dto: Partial<Omit<ReleaseDto, "id" | "name">> },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(UPDATE_RELEASE(id), dto);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data ?? error.message);
    }
  }
);

export const getCustomerLatestReleaseSignatureAction = createAsyncThunk(
  "customerReleaseSignature/getLatest",
  async (
    { customerId, releaseName = "ADDRESS_WAIVER" }: { customerId: number; releaseName?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get(
        GET_CUSTOMER_LATEST_RELEASE_SIGNATURE(customerId),
        { params: { releaseName } }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data ?? error.message);
    }
  }
);
